module.exports = __webpack_public_path__ + "media/src/images/page01_faq04-4d6d988058111a07171dc5b1f6edafa0.gif";